import React from 'react'
import PropTypes from 'prop-types'

class Ausbildungsnachweis extends React.Component {
  render() {
    if (this.props.hasComment) {
      return (
        <>
          <svg width="56" height="72">
            <path d="M2 0C.9 0 0 .9 0 2v68c0 1.1.9 2 2 2h52c1.1 0 2-.9 2-2V16L40 0H2z" fill="#eaeaea" />
            <path d="M40 13c0 1.66 1.34 3 3 3h13L40 0v13z" fill="#999" />
            <g fill="#999">
              <path d="M8 54h36v2H8zM8 60h20v2H8z" />
            </g>
          </svg>
        </>
      )
    } else {
      return (
        <>
          <svg width="56" height="72">
            <path d="M2 0C.9 0 0 .9 0 2v68c0 1.1.9 2 2 2h52c1.1 0 2-.9 2-2V16L40 0H2z" fill="#eaeaea" />
            <path d="M40 13c0 1.66 1.34 3 3 3h13L40 0v13z" fill="#999" />
          </svg>
        </>
      )
    }
  }
}

Ausbildungsnachweis.propTypes = {
  hasComment: PropTypes.bool,
}

export default Ausbildungsnachweis
